module.exports = __webpack_public_path__ + "static/media/white_logo.b246c6c4.png";